<template>
	<div class="home h-100">
		<installPrompt></installPrompt>
		<button v-if="updateExists"
				class="btn btn-hero-success btn-block mb-4"
				@click="refreshApp">
      {{$t('install new version')}}
		</button>
		<div class="row h-100">

			<div class="col">				
				<div class="d-flex " v-if="!onScan">
          <div class="col-8" @click.stop="teamid=null" v-if="!isNeedToSelectCalendrierId">
              <i class="fas fa-truck" style="color: #2d71e6;"></i><span class="font-weight-bold"> {{selectedCalendrierLibelle}} </span ><br>
              <span v-if="selectedSalariesNames"><i class="fa fa-user-friends"></i> {{selectedSalariesNames}}</span>
          </div>
          <div class="col-4 text-center">
            <img src="/img/logo.png" style="max-height:100px;">
          </div>
				</div>

        <div class="sticky-top embed-responsive embed-responsive-1by1 w-100 h-100" v-show="onScan">
          <video class="embed-responsive-item" id="qrscan"></video>
        </div>

        <template v-show="!onScan">

          <div v-if="isNeedToSelectCalendrierId">
            <div class="form-group px-2">
              <label for="">{{$t('Colleague(s) intervening')}}</label>
              <select class="form-control" v-model="salarieids" multiple size="1" name="salarie[]">
                <option v-for="salarie in config.salaries"
                        :value="salarie.id" :key="`salarie-`+salarie.id">{{salarie.name}}</option>
              </select>
            </div>

            <!-- <button class="btn btn-block btn-hero-primary btn-hero-lg mt-4 py-4" value="scan" @click="starscan()" v-show="!onScan">{{$t('Scan the vehicle')}}</button> -->
            <button class="btn  btn-block " value="scan" @click="stopscan()" v-show="onScan">{{$t('Cancel')}}</button>

            <div v-if="selectionManuelleEquipe" class="form-group px-2">
              <label for="">{{$t('Team')}}</label>
              <select class="form-control" v-model="teamid">
              <option value="">{{$t('Please choose a team')}}</option>
                <option v-for="cal in config.calendriers"
                :value="cal.id" :key="`calendrier-`+cal.id">{{cal.libelle}}</option>
              </select>
            </div>
          </div>

          <list-events v-show="teamid"></list-events>
          <br><br>
        </template>

      </div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import installPrompt from '@/components/installPrompt.vue';
	import ListEvents from '@/components/ListEvents.vue';
	import {mapActions, mapGetters} from 'vuex'

  import QrScanner from 'qr-scanner';

  let qrScanner = null;

	export default {
		name: 'home',
		components: {
			ListEvents,
			installPrompt
		},
		data: function () {
			return {
				refreshing: false,
				registration: null,
				updateExists: false,
        selectionManuelleEquipe: true,
        onScan: false,
				teams: []
			}
		},
    created() {
      let self = this;
			// Listen for swUpdated event and display refresh snackbar as required.
			document.addEventListener('swUpdated', this.showRefreshUI, {once: true});
			// Refresh all open app tabs when a new service worker is installed.
			navigator.serviceWorker.addEventListener('controllerchange', () => {
				if (this.refreshing) return;
				this.refreshing = true;
				window.location.reload();
			});
			this.setPageTitle(this.$t('Home'));
		},
		computed: {
			// mix the getters into computed with object spread operator
			...mapGetters('config', {'config': 'getConfig', 'getCalendrierId': 'getCalendrierId', 'withSalarieIds': 'withSalarieIds', 'isNeedToSelectCalendrierId' : 'isNeedToSelectCalendrierId'}),
			teamid : {
				get(){
					return this.getCalendrierId;
				},
				set(id){
					if (!this.getCalendrierId){
						this.$store.dispatch('config/setCalendrierId', id);
						this.$store.dispatch('events/refresh', id);
					} else if (id == null || confirm('Êtes vous certains de vouloir changer d\'équipe ?')) {
						this.$store.dispatch('config/setCalendrierId', id);
						this.$store.dispatch('events/refresh', id);
					}

				}
			},
			salarieids : {
				get(){
					return this.withSalarieIds;
				},
				set(ids){
					this.$store.dispatch('config/setWithSalarieIds', ids);
				}
			},
      selectedCalendrierLibelle : function(){
        if (this.config.calendriers && this.teamid){
          let self = this;
          let calendrier = _.find(this.config.calendriers, function(c){ return c.id == self.teamid });
          return calendrier ? calendrier.libelle : '';
        }
        return '';
      },

      selectedSalariesNames : function(){
        let self = this;
        let retour = '';
        if (this.config.salaries && this.salarieids){
          this.salarieids.forEach(function(idsalarie) {

            let s = _.find(self.config.salaries, function(v){ return v.id == idsalarie });
            retour += s.name + ', ';
          });

            return  retour.slice(0, -2);;
        }

        return '';
      }
		},
		methods: {
			...mapActions('config', ['setPageTitle','changeLocale']),
      starscan: function(){
        this.onScan = true;
        let self = this;

        this.$nextTick(function (){
          const video = document.getElementById('qrscan');
          qrScanner = new QrScanner(video, self.afterscan)
          qrScanner.start();
        });

      },
      // bouton stop
      stopscan: function (){
        qrScanner.stop();
        this.onScan = false;

      },

      afterscan: function (result) {
        this.stopscan();
        //result = 'GB194SA';
        // recherche le calendrier par le libelle c'est à dire numéro de plaque sur le QR Code
        const searchObject = this.config.calendriers.find((calendrier) => calendrier.libelle == result);

        if (searchObject){
          this.teamid = searchObject.id;
        }else{
          alert('QR Code non reconu');
          this.teamid = null;
        }

      },
			showRefreshUI(e) {
				// Display a button inviting the user to refresh/reload the app due
				// to an app update being available.
				// The new service worker is installed, but not yet active.
				// Store the ServiceWorkerRegistration instance for later use.
				this.registration = e.detail;
				this.updateExists = true;
			},
			refreshApp() {
				// Handle a user tap on the update app button.
				this.updateExists = false;
				// Protect against missing registration.waiting.
				if (!this.registration || !this.registration.waiting) {
					return;
				}
				this.registration.waiting.postMessage({type: 'SKIP_WAITING'});
			},
		},
	}
</script>
